// Публичный адрес объекта в S3 — build-time ENV, как VUE_APP_API_URL (см. utils/apiBase.js).
//
// Бакет разный по окружениям: production — `rentprog`, staging — `rentprogstaging`
// (config/credentials/*.yml.enc и YANDEX_S3_BUCKET в .kamal/secrets* на бэкенде).
// Раньше хост бакета был зашит в 15 местах строкой
// `https://rentprog.storage.yandexcloud.net/...`, поэтому на стенде фронт строил
// ссылки в ПРОД-бакет: файл уходил в rentprogstaging, а ссылка вела в rentprog →
// 404 NoSuchKey и неработающая генерация docx-договоров (шаблон тянется по этой
// ссылке прямо из браузера).
//
// Ссылку, которая уходит в базу, теперь пересобирает сервер по ключу объекта
// (concern S3PublicUrl в rentalman-api) — здесь остаётся то, что нужно самому
// фронту: показать файл сразу после загрузки и открыть объект, для которого в
// ответе API есть только ключ.
//
// Значения: .env.production / .env.staging. В dev переменная пустая — бэкенд с
// development-кредами ходит в тот же бакет `rentprog`, поэтому fallback верный.

const LEGACY_PRODUCTION_FALLBACK = "https://rentprog.storage.yandexcloud.net";

let missingEnvReported = false;

function resolveBase() {
  const configured = process.env.VUE_APP_S3_PUBLIC_URL;
  if (configured) return String(configured).replace(/\/+$/, "");

  // Гейт НЕ по NODE_ENV: у custom-режимов Vue CLI 5 берёт NODE_ENV из того же
  // .env.<mode>, отсутствие которого мы и диагностируем (`build --mode eu` без
  // .env.eu даёт NODE_ENV=development, и сообщение молчало бы ровно в аварии).
  // Поэтому ругаемся в любой сборке, кроме unit-сюиты, где NODE_ENV=test ставит
  // раннер и переменной нет по определению.
  if (process.env.NODE_ENV !== "test" && !missingEnvReported) {
    missingEnvReported = true;
    // eslint-disable-next-line no-console
    console.warn(
      "[s3PublicUrl] VUE_APP_S3_PUBLIC_URL is empty — " +
      "falling back to production bucket (" + LEGACY_PRODUCTION_FALLBACK + "). " +
      "In dev это ожидаемо (dev-креды бэкенда смотрят в тот же бакет); " +
      "в сборке staging/EU это значит, что .env файл отсутствует или режим сборки не тот."
    );
  }
  return LEGACY_PRODUCTION_FALLBACK;
}

// Чистая склейка — вынесена отдельно, чтобы её можно было проверить тестом:
// в бандле VUE_APP_* подставляется на этапе сборки и в рантайме не меняется.
export function joinS3Url(base, key) {
  if (!key) return "";

  const normalizedKey = String(key).replace(/^\/+/, "");
  // Записи, где вместо ключа уже лежит полная ссылка, отдаём как есть.
  if (/^https?:\/\//i.test(normalizedKey)) return normalizedKey;

  return `${String(base).replace(/\/+$/, "")}/${normalizedKey}`;
}

export const S3_PUBLIC_BASE = resolveBase();

// FT-007: база бакета ЯЧЕЙКИ компании — приходит в ответе входа (storage_urls[region]) и лежит в сторе.
// Build-time база одна на сборку (prod — RU-бакет): у компании EU ссылка на новый файл вела бы в RU.
// Провайдер, а не значение: стор восстанавливается из localStorage без мутаций, и база должна читаться
// из текущего состояния в момент склейки. Модуль не импортирует стор — провайдер регистрирует сам стор.
let baseProvider = null;

// Возвращает прежний провайдер — чтобы тест, подменивший его, мог вернуть провайдер стора.
export function setS3BaseProvider(provider) {
  const previous = baseProvider;
  baseProvider = typeof provider === "function" ? provider : null;
  return previous;
}

// Только схема, хост и порт: путь, query, fragment и учётные данные сломали бы склейку с ключом (ревью Codex).
const VALID_BASE = /^https:\/\/[A-Za-z0-9.-]+(:\d+)?\/?$/;

function runtimeBase() {
  const base = baseProvider && baseProvider();
  return typeof base === "string" && VALID_BASE.test(base) ? base : null;
}

export function s3PublicUrl(key) {
  return joinS3Url(runtimeBase() || S3_PUBLIC_BASE, key);
}
